<template>
  <Content id="users">

    <div slot="search">
      <Form :label-width="50" :model="search">
        <Row>
          <Col><FormItem label="文件名" :label-width="65"><Input v-model="search.name"/></FormItem></Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status" style="width: 100%;">
                <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="日期">
              <DatePicker  style="width:114px ;" type="date" :editable="false" placeholder="开始日期" format="yyyy-MM-dd" v-model="search.startDate"  @on-change="changestart"></DatePicker>
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="结束日期" format="yyyy-MM-dd" v-model="search.endDate" @on-change="changeend"></DatePicker>
            </FormItem>
          </Col>
          <Col><div style="display:flex;">&nbsp;&nbsp;<Button type="primary" @click="query">查询</Button></div></Col>
        </Row>
      </Form>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed="left" align="center" prop="taskName" label="体检任务" show-overflow-tooltip  min-width="150"/>
      <el-table-column fixed="left" align="center" prop="schoolName" label="学校名称" show-overflow-tooltip  min-width="150"/>
      <el-table-column fixed="left" align="center" prop="fileName" label="文件名" show-overflow-tooltip  min-width="300">
        <template slot-scope="{row}" slot="fileName">
          {{row.fileName?row.fileName.replace(row.fileName.substring(row.fileName.lastIndexOf("_"), row.fileName.lastIndexOf(".")), ""):''}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="type" label="类型"  min-width="100">
        <template slot-scope="{row}">{{ typesList.filter(u => u.value === row.type)[0].label }}</template>
      </el-table-column>
      <el-table-column align="center" prop="times" label="用时(s)" min-width="50"/>
      <el-table-column align="center" prop="total" label="总数" min-width="50"/>
      <el-table-column align="center" prop="completeNum" label="完成数量" min-width="80"/>
      <el-table-column align="center" prop="createTime" label="操作时间" min-width="120"/>
      <el-table-column align="center" prop="status" label="状态" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.status === 3 ? 'success' :
                                      row.status === 2 || row.status === 6 ? 'warning' :
                                      row.status === 1 ? 'primary' :
                                      row.status === 4 || row.status === 7 ? 'danger' : 'info'" disable-transitions v-if="row.status">
            {{ statusList.filter(u => u.value === row.status)[0].label }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="80">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="downloadFile(row)" :disabled="!(row.status===2||row.status===3)">文件下载</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 20, 40, 80]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

  </Content>
</template>
<script>
import {_page,_download} from "@/services/inputOutput/outputLog.js";
import {mixins} from "@/mixins/index.js";
export default {
  name: "BatchOutputLog",
  mixins: [mixins],
  data() {
    return {
      currentRowIndex:-1,
      search: {
        fileName: "",
        startDate: "",
        endDate: "",
        status: "",
      },
      dataList: [],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      typesList:[
        {label: '下载体检报告', value: 1},
        {label: '批量下载体检报告', value: 2},
        // {label: '评价分析报告', value: 3},
        // {label: '评价分析报告异常名单', value: 4},
      ],
      disabled: false,
      refreshing: false,
      toQuery: true,
      statusList:[
        {label: '生成中', value: 1},
        {label: '部分成功', value: 2},
        {label: '已生成', value: 3},
        {label: '生成失败', value: 4},
        {label: '已下载', value: 5},
        {label: '正在下载中...', value: 6},
        {label: '下载失败', value: 7},
      ],
    };
  },
  watch: {
    '$route.path': {
      handler(newData, oldData) {
        if(newData && newData.length > 0 && newData === '/batch-output-log/page' && this.$userSession.checkInstitutionId()){
          this.handleDataList();
        }
      },
    }
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  onReady(){
    if (this.$userSession.checkInstitutionId()) {
      this.toQuery = true;
      this.handleDataList();

      let _this = this;
      let interval = setInterval(function(){
        let menuActive = localStorage.getItem("menuActive");
        if(menuActive && menuActive.indexOf("/batch-output-log/page") != -1 && _this.toQuery){
          _this.handleDataList();
        }else{
          clearInterval(interval);
        }
      }, 5000);
    }
  },
  onLoad(){

  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList(); // 获取列表数据

      let _this = this;
      if(!_this.refreshing){
        let interval = setInterval(function(){
          let menuActive = localStorage.getItem("menuActive");
          if(menuActive && menuActive.indexOf("/downloadLog/selectPages") != -1 && _this.toQuery){
            console.log("初始化刷新下载页面。。。");
            _this.refreshing = true;
            _this.handleDataList();
          }else{
            clearInterval(interval);
            _this.refreshing = false;
          }
        }, 5000);
      }
    }
  },
  // 使用 beforeRouteEnter 守卫
  beforeRouteEnter(to, from, next) {

    // console.log('即将进入页面：' + to.name + '  来自页面：' + from.name);
    // 执行 next，并通过回调函数访问组件实例
    next(vm => {
      if(!vm.refreshing){
        vm.toQuery = true;
        console.log("刷新下载页面。。。");
        vm.refreshing = true;
        vm.refresh();
      }
    });
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      let _this = this;
      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        if (res.errcode == 1){
          this.dataList = res.data.records;
          this.pageList.total = res.data.total;

          if(this.pageList.total > 2 && (this.dataList[0].status == 2 || this.dataList[0].status == 3 || this.dataList[0].status == 4 || this.dataList[0].status == 5 || this.dataList[0].status == 7)
            && (this.dataList[1].status == 2 || this.dataList[1].status == 3 || this.dataList[1].status == 4 || this.dataList[1].status == 5 || this.dataList[1].status == 7)
            && (this.dataList[2].status == 2 || this.dataList[2].status == 3 || this.dataList[2].status == 4 || this.dataList[2].status == 5 || this.dataList[2].status == 7)) {
            _this.toQuery = false;
          }else if(this.pageList.total == 2 && (this.dataList[0].status == 2 || this.dataList[0].status == 3 || this.dataList[0].status == 4 || this.dataList[0].status == 5 || this.dataList[0].status == 7)
            && (this.dataList[1].status == 2 || this.dataList[1].status == 3 || this.dataList[1].status == 4 || this.dataList[1].status == 5 || this.dataList[1].status == 7)) {
            _this.toQuery = false;
          }else if(this.pageList.total == 1 && (this.dataList[0].status == 2 || this.dataList[0].status == 3 || this.dataList[0].status == 4 || this.dataList[0].status == 5 || this.dataList[0].status == 7)) {
            _this.toQuery = false;
          }else if(this.pageList.total > 0 && (this.dataList[0].status == 1 || this.dataList[0].status == 6)) {
            _this.toQuery = true;
          }else if(this.pageList.total > 1 && (this.dataList[0].status == 1 || this.dataList[0].status == 6 || this.dataList[1].status == 1 || this.dataList[1].status == 6)) {
            _this.toQuery = true;
          }else if(this.pageList.total == 0){
            _this.toQuery = false;
          }
        } else {
          _this.toQuery = false;
          _this.refreshing = false;
          this.$message({
            type: 'error',
            message: res.errmsg,
            duration: 4000
          });
        }
      }).catch(() => {});
    },
    downloadFile(row){
      if(row.status == 1) {
        this.$message.warning('正在生成中不能下载');
        return;
      }else if(row.status == 5) {
        this.$message.warning('文件已失效');
        return;
      }
      row.status = 6;

      let _this = this;
      _download({id: row.id, serverIp: row.serverIp},'application/octet-stream',function (){

      }, function (){
        _this.$message.success('下载完成');
        _this.handleDataList();
      }).then(res => {
      }).catch((err) => {
        _this.$message.error('下载失败');
        _this.handleDataList();
      }).finally(() => {
        _this.toQuery = false;
        _this.refreshing = false;
      })

    },
    refresh(){
      let _this = this;
      let count = 20;
      let interval = setInterval(function(){
        if(_this.toQuery && count > 0){
          _this.handleDataList();
          count--;
        }else{
          clearInterval(interval);
          _this.refreshing = false;
        }
      }, 5000);
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    changestart(e) {
      this.search.startDate = e
    },
    changeend(e) {
      this.search.endDate = e
    },
  }
};
</script>
<style lang="postcss" scoped>

</style>
